import React from "react";
import clsx from "clsx";
import "./LoadingSpinner.scss";
import { Spinner } from "react-bootstrap";

interface ILoadingSpinnerProps {
    className?: string;
    raised: boolean;
    fullPage?: boolean;
    [key: string]: any;
}

const LoadingSpinner: React.FC<ILoadingSpinnerProps> = ({
    className,
    raised,
    fullPage = false,
    ...rest
}) => {
    if (!raised) return null;

    return (
        <div
            className={clsx(
                "LoadingSpinner",
                { "LoadingSpinner--fullPage": fullPage },
                className,
            )}
            {...rest}
        >
            <Spinner animation="border" />
        </div>
    );
};

export default LoadingSpinner;
